import {
  TlfArsListingReadDto,
  TlfArsMasterReadDto,
  TlfArsTableReadDto,
} from "functions/api/tlfItem/TlfItemReadDto";
/**
 * Removes patch metadata from an ARS master to retain its baseline TLF snapshot.
 *
 * @param master - ARS master DTO containing the current patch catalog
 * @returns Shell DTO without patch or variant-template metadata
 */
export const toArsTlfSnapshot = (
  master: TlfArsMasterReadDto,
): TlfArsTableReadDto | TlfArsListingReadDto => {
  const {
    allVariantPatches: _allVariantPatches,
    variantTemplates: _variantTemplates,
    ...snapshot
  } = master;
  return snapshot;
};
